"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.func_sum = exports.getAllIndexes = exports.getParamsFromConfigData = exports.getActivitiesInModule = void 0;
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var getActivitiesInModule = function (moduleId, data) {
    var module = data.modules.find(function (mod) { return mod.id === moduleId; });
    if (!module)
        throw new Error("Module not found");
    return module.objectiveIds
        .map(function (objectiveId) {
        var objective = data.objectives.find(function (objective) { return objective.id === objectiveId; });
        if (!objective)
            throw new Error("Objective not found: " + objectiveId);
        return objective.activityIds;
    })
        .reduce(function (flattened, activityIds) { return __spreadArray(__spreadArray([], __read(flattened), false), __read(activityIds), false); }, [])
        .map(function (activityId) {
        var activity = data.activities.find(function (activity) { return activity.id === activityId; });
        if (!activity)
            throw new Error("Activity not found: " + activityId);
        return activity;
    });
};
exports.getActivitiesInModule = getActivitiesInModule;
var getParamsFromConfigData = function (_config, data, moduleId) {
    var config = (0, cloneDeep_1.default)(_config);
    var paramsGraph = __assign(__assign({}, config.baseConfig.graph), { graph: config.moduleConfig[moduleId], main_act: moduleId, exercises_ontology: (0, exports.getActivitiesInModule)(moduleId, data), exercisesMetaData: data.exercises });
    if (config.initialTest)
        paramsGraph["initialTest"] = config.initialTest[moduleId];
    return __assign(__assign({}, config.baseConfig), { graph: paramsGraph });
};
exports.getParamsFromConfigData = getParamsFromConfigData;
function getAllIndexes(arr, val) {
    var indexes = [], i;
    for (i = 0; i < arr.length; i++)
        if (arr[i] === val)
            indexes.push(i);
    return indexes;
}
exports.getAllIndexes = getAllIndexes;
function func_sum(array) {
    var sum1 = array.reduce(function (accumulator, currentValue) { return accumulator + currentValue; });
    return sum1;
}
exports.func_sum = func_sum;
